export const APP_CONFIG = Object.freeze({
  // DEFAULT_API_BASE_URL: 'http://localhost:8080',
  // DEFAULT_API_BASE_URL: 'https://healo-stg.clarimed.ai',
  DEFAULT_API_BASE_URL: 'https://evia.clarimed.ai',
  // Base URL for electron-release-server. A plain host also works; the app appends
  // /release-server automatically when it is missing.
  // UPDATE_SERVER_BASE_URL: 'https://healo.cubegames.pl/release-server',
  UPDATE_SERVER_BASE_URL: 'https://healo-stg.clarimed.ai/release-server',
  // UPDATE_FOR_PLATFORMS: ['win32', 'darwin'],
  UPDATE_FOR_PLATFORMS: ['win32'],
  CHECK_FOR_UPDATES_ON_STARTUP: true,
  // First day of the week shown in date pickers and calendar grids.
  // 0 = Sunday, 1 = Monday, ... 6 = Saturday (react-day-picker / date-fns convention).
  WEEK_STARTS_ON: 7,
});
